import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, OnInit, signal } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import { IconChevronDownComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-product-option-selector-wrapper',
  templateUrl: './product-option-selector-wrapper.component.html',
  styleUrls: ['./product-option-selector-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective, IconChevronDownComponent, NgClass, TagComponent],
})
export class ProductOptionSelectorWrapperComponent implements OnInit {
  name = input.required<string>();
  instructions = input.required<string>();

  isOptional = input<boolean>();
  isRequired = input<boolean>();
  displayCondition = input<boolean>(false);
  collapsible = input<boolean>(false);
  initialIsOpen = input<boolean>(false);

  isOpen = signal<boolean>(false);

  displayContent = computed(() => !this.collapsible() || this.isOpen());

  ngOnInit() {
    this.isOpen.set(this.initialIsOpen());
  }

  toggleIsOpen() {
    this.isOpen.update(isOpen => !isOpen);
  }
}
